import MuiForm from "rjsf-material-ui";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Button from "sushiweb/Button";
import * as GenSettingActions from "../../../store/actions/GenSetting";
import * as CityPropertyActions from "../../../store/actions/CityProperty";
import * as UserActions from "../../../store/actions/User";
import { clean } from "../HelperFunctions";
import { isEmpty } from "../../../utils/index";
import ErrorMsgs from "../../../constants/Errors.json";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  button: {
    marginTop: "1.25rem",
    marginBottom: "1.25rem",
    className: "shushi-btn",
    width: "12.5rem",
    height: "2.75rem",
  },
}));

const formschema = {
  type: "object",
  required: ["priority", "activation", "actions"],
  properties: {
    priority: {
      type: "integer",
      title: "Priority",
    },
    activation: {
      type: "object",
      title: "Activation",
      default: {},
      required: [],
      properties: {
        remaining_assignment_time: {
          type: "number",
          title: "remaining_assignment_time",
        },
        cell_assignment_time: {
          type: "number",
          title: "cell_assignment_time",
        },
      },
    },
    actions: {
      type: "object",
      title: "Actions",
      default: {},
      required: [],
      properties: {
        self: {
          type: "object",
          title: "self",
          required: [],
          properties: {
            assignment_radius_multiplier: {
              type: "number",
              title: "assignment_radius_multiplier",
            },
            cost_multiplier: {
              type: "number",
              title: "cost_multiplier",
            },
            angle_multiplier: {
              type: "number",
              title: "angle_multiplier",
            },
            detour_multiplier: {
              type: "number",
              title: "detour_multiplier",
            },
            order_ready_threshold_delta: {
              type: "number",
              title: "order_ready_threshold_delta",
            },
            breach_threshold: {
              type: "number",
              title: "breach_threshold",
            },
            first_drop: {
              type: "boolean",
            },
            delay_assignment_config: {
              type: "object",
              title: "delay_assignment_config",
              required: [],
              properties: {
                disable_delayed_assignment: {
                  type: "boolean",
                  title: "disable_delayed_assignment",
                },
              },
            },
          },
        },
        others: {
          type: "object",
          title: "others",
          required: [],
          properties: {
            segment_batching_config: {
              type: "array",
              title: "segment_batching_config",
              items: {
                type: "object",
                properties: {
                  breach_threshold_delta: {
                    type: "number",
                    title: "breach_threshold_delta",
                  },
                  segment: {
                    type: "number",
                    title: "segment",
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

const AddLevelForm = (props) => {
  const classes = useStyles();
  const {
    modalState,
    handleModalClose,
    activeRule,
    setActiveRule,
    activeCityProperty,
    activeGenSetting,
    finalConfig,
    levelSchema,
    setStatus,
    createdRule,
  } = props;
  const [formData, setFormData] = useState(null);
  const [formError, setformError] = useState("");

  const handleChange = (e) => {
    setFormData(e.formData);
  };

  const handleSubmit = () => {
    if (!isEmpty(activeCityProperty)) {
      activeRule.is_city_property = true;
    }
    // set final config
    clean(formData);
    formData.actions = formData.actions == undefined ? {} : formData.actions;
    formData.activation =
      formData.activation == undefined ? {} : formData.activation;
    let newfinalConfig = JSON.parse(JSON.stringify(finalConfig));
    newfinalConfig = newfinalConfig.map((rule) => {
      if (
        rule.rule_name == activeRule.rule_name &&
        rule.priority == activeRule.priority
      ) {
        if (!isEmpty(activeCityProperty)) {
          rule.is_city_property = true;
        }
        rule.is_modified = true;
        if (rule.levels != undefined) {
          rule.levels.push(formData);
        } else {
          rule.levels = [formData];
        }
        rule.levels.sort((a, b) =>
          a.priority < b.priority ? 1 : b.priority < a.priority ? -1 : 0
        );
      }
      return rule;
    });
    props.setFinalConfig({
      rules: newfinalConfig,
    });

    let ruleFound = false;
    // check if that rule was inherited from Cp or Gs and then push the new level inside its correct place
    try {
      // check if the edit is being done in newly created rule
      if (!isEmpty(createdRule) && activeRule.is_new != undefined) {
        createdRule.levels.push(formData);
        props.setcreatedRule(createdRule);
      }
      // if a city is selected then update city property
      else if (!isEmpty(activeCityProperty)) {
        if (activeCityProperty.value.rules == undefined) {
          activeCityProperty.value.rules = [activeRule];
        } else {
          activeCityProperty.value.rules.map((rule) => {
            if (
              rule.rule_name == activeRule.rule_name &&
              rule.priority == activeRule.priority
            ) {
              rule.is_modified = true;
              rule.levels.push(formData);
              ruleFound = true;
            }
            return rule;
          });
        }

        if (!ruleFound) {
          if (activeRule.levels != undefined) {
            activeRule.levels.push(formData);
          } else {
            activeRule.levels = [formData];
          }
          activeCityProperty.value.rules.push(activeRule);
        }
        props.setActiveCityProperty(activeCityProperty);
      } else {
        // if none of the above is true then gen-setting rule is updated
        activeGenSetting.value.rules.map((rule) => {
          if (
            rule.rule_name == activeRule.rule_name &&
            rule.priority == activeRule.priority
          ) {
            rule.is_modified = true;
            rule.levels.push(formData);
          }
        });
        props.setActiveGenSetting(activeGenSetting);
      }
    } catch (error) {
      setFormData(null);
      setActiveRule(null);
      setformError("");
      handleModalClose();
      setStatus({
        type: "error",
        message: typeof error === "string" ? error : ErrorMsgs.GENERAL_ERROR_1,
      });
    }
    setFormData(null);
    setActiveRule(null);
    setformError("");
    handleModalClose();
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={!!modalState}
        onClose={handleModalClose}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="scroll-dialog-feature"
        aria-describedby="scroll-dialog-description"
        id="addLevelFormModal"
      >
        <AppBar className={classes.appBar} color="transparent">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleModalClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              <b>Add Level</b>
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <MuiForm
            formData={formData}
            onChange={handleChange}
            onSubmit={handleSubmit}
            schema={!isEmpty(levelSchema) ? levelSchema : formschema}
            omitExtraData={true}
          >
            <div style={{ float: "right" }}>
              <Button className={classes.button} size="compressed">
                {" "}
                {"Submit"}{" "}
              </Button>
            </div>
          </MuiForm>
        </DialogContent>
      </Dialog>
      {formError.length > 0 ? (
        <div className={`error-state ${classes.errorSpacing}`}>
          {"*" + formError}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { GenSetting, CityProperty } = state;
  return {
    levelSchema: GenSetting.levelSchema,
    finalConfig: GenSetting.finalConfig,
    activeGenSetting: GenSetting.activeGenSetting,
    activeCityProperty: CityProperty.activeCityProperty,
    createdRule: GenSetting.activeRule,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFinalConfig: bindActionCreators(
      GenSettingActions.setFinalConfig,
      dispatch
    ),
    setActiveGenSetting: bindActionCreators(
      GenSettingActions.setActiveGenSetting,
      dispatch
    ),
    setActiveCityProperty: bindActionCreators(
      CityPropertyActions.setActiveCityProperty,
      dispatch
    ),
    setcreatedRule: bindActionCreators(
      GenSettingActions.setActiveRule,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddLevelForm);
